import getDefaultRequest, { getAuthRequest } from "./API.js";

export const Auth = () => {
  const login = async (email, password) => {
    try {
      return await getDefaultRequest().post("auth/login", { email, password });
    } catch (error) {
      return error.response;
    }
  };

  const logout = async (token) => {
    try {
      return await getAuthRequest(token).post("auth/logout");
    } catch (error) {
      return error.response;
    }
  };

  return {
    login,
    logout,
  };
};